var _polygon, _polygon2, _polygon3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCraBreach({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "17.24 11.07 16.24 12.07 17.24 13.07 21 13.07 21 11.07 17.24 11.07"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "7.76 12.07 6.76 11.07 3 11.07 3 13.07 6.76 13.07 7.76 12.07"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    points: "17.66 7.83 16.24 6.42 12 10.66 7.76 6.42 6.34 7.83 10.59 12.07 6.34 16.32 7.76 17.73 12 13.49 16.24 17.73 17.66 16.32 13.41 12.07 17.66 7.83"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCraBreach);
export default __webpack_public_path__ + "static/media/cra-breach.412a2ab88ee178e8b1b2b46c42a72295.svg";
export { ForwardRef as ReactComponent };